export default __webpack_public_path__ + "static/media/Message_light.c16653bc.svg";